import { createIcon } from '../icon'
import DiscountCouponIcon from '@/components/atoms/svg/DiscountCouponIcon'

export const DiscountCouponIconDefault = createIcon(DiscountCouponIcon)
